import { render, staticRenderFns } from "./EditSectionName.vue?vue&type=template&id=a9636380&scoped=true&"
import script from "./EditSectionName.vue?vue&type=script&lang=js&"
export * from "./EditSectionName.vue?vue&type=script&lang=js&"
import style0 from "./EditSectionName.vue?vue&type=style&index=0&id=a9636380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9636380",
  null
  
)

export default component.exports